import api from '@/legacy/services/api';
import { TablePayloadToSend } from '../types';

type FetchDataId = Record<string, string | number | boolean | (string | number | boolean)[]>;

export const fetchTableData = async <T>(
	url: string,
	body: TablePayloadToSend,
	queryParamId?: FetchDataId,
): Promise<T> => {
	if (queryParamId) {
		const queryString = Object.entries(queryParamId)
			.map(([key, value]) =>
				Array.isArray(value)
					? value.map((v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`).join('&')
					: `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
			)
			.join('&');
		url = `${url}?${queryString}`;
	}
	const response = await api.post(url, body);
	return response.data as T;
};
